module.exports = __webpack_public_path__ + "aaf984b7e446a01ac31922c6f002cfdd.png";